import { z } from "zod";

import { ExperienceCategoryList } from "../../../dtos/experiences";
import { ExperienceListDtoSchema } from "../../../dtos/experiences-list";

export const GetExperiencesListQueryParamSchema = z.object({
  category: z.enum(ExperienceCategoryList).optional(),
});

export type GetExperiencesListQueryParamType = z.infer<
  typeof GetExperiencesListQueryParamSchema
>;

export const GetExperiencesListResponseBodySchema = z.object({
  experiencesList: ExperienceListDtoSchema.array(),
});

export type GetExperiencesListResponseBodyType = z.infer<
  typeof GetExperiencesListResponseBodySchema
>;
